import { render, staticRenderFns } from "./NflBestBet.vue?vue&type=template&id=6554f0e1&scoped=true"
import script from "./NflBestBet.vue?vue&type=script&lang=js"
export * from "./NflBestBet.vue?vue&type=script&lang=js"
import style0 from "./NflBestBet.vue?vue&type=style&index=0&id=6554f0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554f0e1",
  null
  
)

export default component.exports